import { FunctionComponent, useEffect } from "react";
import ContactForm from "../../components/ContactForm";
import "./styles.scss";
import CatalogArea from "../../components/CatalogArea";
import Footer from "../../components/Footer";
import { ScrollToTopOnMount } from "../../components/common/ScrollToTopOnMount";

const ContactPage: FunctionComponent = () => {
  return (
    <>
      <ScrollToTopOnMount />
      <section className="contact_page_container">
        <section className="contact_data">
          <div className="contact_message">
            <h1 className="contact_h1">Contacto</h1>
            <p className="contact_text">Envíenos un mensaje y nos pondremos en contacto!</p>
            <ContactForm />
          </div>
          <div className="contact_location">
            <h1 className="contact_h1">Dónde estamos</h1>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.9624069674746!2d-58.38620758881346!3d-34.60511210745877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccac5780a5109%3A0xe7b44b56580220ee!2sRTabak!5e0!3m2!1ses!2ses!4v1685351045274!5m2!1ses!2ses"
              width="600"
              height="450"
              style={{ border: 0 }}
              className="contact_location_screen"
              loading="lazy"
            ></iframe>
            <div className="contact_location_data">
              <p className="contact_location_text">Libertad 262 - Local 11 - CABA. Buenos Aires, Argentina.</p>
              <p className="contact_location_text">
                Whatsapp:{" "}
                <a href="https://wa.me/541154118520" target={"_blank"}>
                  (54911) 5411-8520
                </a>
              </p>
              <p className="contact_location_text">Tel.: (5411) 4382-7516/6150</p>
              <a className="contact_location_mailTo" href="mailto:info@rtabak.com.a">
                info@rtabak.com.ar
              </a>
            </div>
          </div>
        </section>
        <CatalogArea />
      </section>
      <Footer />
    </>
  );
};

export default ContactPage;
